<ng-container *ngIf="!affirmative" i18n>NOT: </ng-container>
<ng-container *ngFor="let childOperator of childOperators; let childOperatorLast = last">
  <eas-editor-eligibility-operator-title [operator]="childOperator">
  </eas-editor-eligibility-operator-title>
  <ng-container *ngIf="!childOperatorLast">
    {{ function }}
  </ng-container>
</ng-container>
